export var CodeMapper = {
	cnsltn : {
		reqTp : function reqTp(reqTp) {
			if (reqTp === 0) {
				return "FCL";
			} else if (reqTp === 1) {
				return "LCL";
			} else if (reqTp === 2) {
				return "EXPRESS";
			} else if (reqTp === 3) {
				return "MOVE";
			}
		},
		transTp : function transTp(transTp) {
			if (transTp === 0) {
				return "Sea";
			} else if (transTp === 1) {
				return "Air";
			} else if (transTp === 2) {
				return "Sea/Air";
			}
		},
		stusCd : function stusCd(stusCd) {
			if (stusCd === -1) {
				return "견적 요청 수령";
			} else if (stusCd === 0) {
				return "견적 중";
			} else if (stusCd === 1) {
				return "견적 완료";
			} else if (stusCd === 2) {
				return "Booking 요청";
			} else if (stusCd === 3) {
				return "Booking 승인";
			}
		}
	}

};


// WEBPACK FOOTER //
// ./src/app/utils/code-mapper.ts